import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService } from '@examdojo/supabase';
import { from } from 'rxjs';
import { CurrentReviewHttpModel } from '../review-item';

@Injectable({ providedIn: 'root' })
export class ReviewSolutionImagesHttpService extends SupabaseBaseHttpService<'user_images', 'review'> {
  readonly schema = 'review';
  readonly tableName = 'user_images';

  deleteQuestionAttemptResponseImageFile(bucketName: string, path: string) {
    return from(this.supabase.removeFiles(bucketName, path));
  }

  fetchSignedUrls(imageNames: string[], bucketName: string) {
    return this.supabase.getSignedUrlsMapForFiles(bucketName, imageNames);
  }

  fetchAllFromCurrentSession(reviewSession: CurrentReviewHttpModel['review_session']) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .select()
        .eq('current_review_session', reviewSession)
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  fetchAllByReviewableItem(reviewableItemId: CurrentReviewHttpModel['reviewable_item_id']) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .select(
          `
          *,
          actions!inner(reviewable_item_id)
        `,
        )
        .eq('actions.reviewable_item_id', reviewableItemId)
        .throwOnError()
        .then((response) => response.data!),
    );
  }
}
